import CssBaseline from '@material-ui/core/CssBaseline';
import { withNkStyles } from '@nordkap/nordkap-ui';
import PropTypes from 'prop-types';
import React from 'react';

const Layout = ({ children }) => (
  <div>
    <CssBaseline />
    {children}
  </div>
);

Layout.propTypes = {
  children: PropTypes.array,
};

export default withNkStyles(Layout);
